import { LegalLayout } from "@/components/site/LegalLayout";

export default function Datenschutz() {
  return (
    <LegalLayout eyebrow="Rechtliches" title="Datenschutz&shy;erklärung">
      <h2>1. Verantwortlicher</h2>
      <p>Verantwortlich für die Datenverarbeitung auf dieser Website ist:</p>
      <p>
        DirektLab
        <br />
        Siemensstraße 27C
        <br />
        63165 Mühlheim am Main
        <br />
        Deutschland
      </p>
      <p>
        Vertreten durch:
        <br />
        Mandana Gholami, Geschäftsführer
      </p>
      <p>
        Telefon: <a href="tel:+4915222825309">+49 152 22825309</a>
        <br />
        E-Mail:{" "}<a href="mailto:kontakt@direktlab.de">kontakt@direktlab.de</a>
      </p>

      <h2>2. Allgemeine Hinweise</h2>
      <p>
        Der Schutz Ihrer personenbezogenen Daten ist uns wichtig. Wir
        behandeln Ihre personenbezogenen Daten vertraulich und entsprechend
        den geltenden datenschutzrechtlichen Vorschriften, insbesondere der
        Datenschutz-Grundverordnung (DSGVO) und dem Bundesdatenschutzgesetz
        (BDSG).
      </p>
      <p>
        Diese Datenschutzerklärung informiert Sie darüber, welche Daten beim
        Besuch unserer Website erhoben werden, zu welchem Zweck dies geschieht
        und welche Rechte Ihnen zustehen.
      </p>

      <h2>3. Hosting</h2>
      <p>Unsere Website wird bei einem externen Dienstleister gehostet:</p>
      <p>Hostinger International Ltd.</p>
      <p>
        Die Bereitstellung der Website erfolgt im Interesse einer sicheren,
        schnellen und zuverlässigen Darstellung unseres Online-Angebots
        gemäß Art. 6 Abs. 1 lit. f DSGVO.
      </p>
      <p>
        Im Rahmen des Hostings können technisch erforderliche Daten
        verarbeitet werden, insbesondere:
      </p>
      <ul>
        <li>IP-Adresse,</li>
        <li>Datum und Uhrzeit des Zugriffs,</li>
        <li>Browsertyp und Browserversion,</li>
        <li>verwendetes Betriebssystem,</li>
        <li>Referrer-URL,</li>
        <li>angeforderte Seiten und Dateien.</li>
      </ul>
      <p>
        Mit dem Hosting-Anbieter wurde ein Vertrag zur Auftragsverarbeitung
        gemäß Art. 28 DSGVO abgeschlossen.
      </p>
      <p>
        Weitere Informationen finden Sie in der Datenschutzerklärung von
        Hostinger.
      </p>

      <h2>4. Server-Logfiles</h2>
      <p>
        Beim Aufruf unserer Website werden durch den Hosting-Anbieter
        automatisch Informationen in sogenannten Server-Logfiles erhoben und
        gespeichert. Diese umfassen insbesondere:
      </p>
      <ul>
        <li>IP-Adresse des anfragenden Geräts,</li>
        <li>Datum und Uhrzeit des Zugriffs,</li>
        <li>aufgerufene Seite oder Datei,</li>
        <li>Browsertyp und -version,</li>
        <li>Betriebssystem,</li>
        <li>Referrer-URL.</li>
      </ul>
      <p>
        Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO
        zur Gewährleistung der technischen Sicherheit und Stabilität unseres
        Webangebots.
      </p>
      <p>
        Eine Zusammenführung dieser Daten mit anderen Datenquellen erfolgt
        nicht.
      </p>

      <h2>5. Kontaktformular</h2>
      <p>
        Wenn Sie uns über das Kontaktformular kontaktieren, verarbeiten wir
        die von Ihnen angegebenen Daten:
      </p>
      <ul>
        <li>Name,</li>
        <li>E-Mail-Adresse,</li>
        <li>Unternehmen (freiwillige Angabe),</li>
        <li>Ihr Anliegen bzw. Ihre Nachricht.</li>
      </ul>
      <p>
        Die Verarbeitung erfolgt ausschließlich zum Zweck der Bearbeitung
        Ihrer Anfrage und einer möglichen weiteren Kommunikation.
      </p>
      <p>Rechtsgrundlagen hierfür sind:</p>
      <ul>
        <li>
          Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage der Durchführung
          vorvertraglicher Maßnahmen oder der Erfüllung eines Vertrags dient,
        </li>
        <li>
          Art. 6 Abs. 1 lit. f DSGVO aufgrund unseres berechtigten Interesses
          an der effizienten Bearbeitung von Anfragen.
        </li>
      </ul>
      <p>
        Ihre Daten werden nicht an Dritte weitergegeben und nur so lange
        gespeichert, wie dies für die Bearbeitung Ihrer Anfrage erforderlich
        ist oder gesetzliche Aufbewahrungspflichten bestehen.
      </p>

      <h2>6. Kontaktaufnahme per E-Mail oder Telefon</h2>
      <p>
        Wenn Sie uns per E-Mail oder telefonisch kontaktieren, speichern und
        verarbeiten wir die von Ihnen übermittelten personenbezogenen Daten
        ausschließlich zur Bearbeitung Ihres Anliegens.
      </p>
      <p>
        Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO
        beziehungsweise Art. 6 Abs. 1 lit. f DSGVO.
      </p>
      <p>
        Eine Weitergabe an Dritte erfolgt nicht ohne Ihre ausdrückliche
        Einwilligung oder eine gesetzliche Verpflichtung.
      </p>

      <h2>7. Cookies und Tracking-Technologien</h2>
      <p>
        Unsere Website verwendet keine Analyse-, Marketing- oder
        Tracking-Cookies.
      </p>
      <p>
        Es werden keine Dienste zur Auswertung des Nutzerverhaltens
        eingesetzt und keine personenbezogenen Daten zu Werbezwecken
        verarbeitet.
      </p>
      <p>
        Soweit technisch notwendige Cookies durch den Hosting-Anbieter oder
        das eingesetzte Content-Management-System erforderlich sind, erfolgt
        deren Einsatz auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO zur
        technisch fehlerfreien Bereitstellung der Website.
      </p>
      <p>
        Ein Cookie-Consent-Tool wird nicht eingesetzt, da keine
        einwilligungspflichtigen Cookies oder Dienste verwendet werden.
      </p>

      <h2>8. Schriftarten (Google Fonts)</h2>
      <p>
        Diese Website verwendet zur einheitlichen Darstellung von Schriftarten
        sogenannte Web Fonts, die von Google Ireland Limited bereitgestellt
        werden. Beim Aufruf einer Seite werden die benötigten Schriftarten von
        einem Google-Server nachgeladen. Dabei wird Ihre IP-Adresse an Google
        übermittelt.
      </p>
      <p>
        Die Verwendung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO im
        Interesse einer ansprechenden und einheitlichen Darstellung unseres
        Angebots. Weitere Informationen finden Sie in der Datenschutzerklärung
        von Google:{" "}
        <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">
          policies.google.com/privacy
        </a>
        .
      </p>

      <h2>9. Eingebettete Inhalte (Referenz-Vorschau)</h2>
      <p>
        Im Abschnitt „Referenzen" wird eine Live-Vorschau eines unserer
        Projekte über einen sogenannten Iframe eingebunden. Beim Aufruf der
        Seite wird die eingebettete Vorschau-URL kontaktiert, wobei Ihre
        IP-Adresse an den jeweiligen Anbieter übermittelt wird. Rechtsgrundlage
        ist Art. 6 Abs. 1 lit. f DSGVO (Interesse an einer ansprechenden
        Präsentation unserer Referenzen).
      </p>

      <h2>10. Keine weiteren Drittanbieter-Dienste</h2>
      <p>Darüber hinaus werden keine externen Inhalte eingebettet.</p>
      <p>Insbesondere verwenden wir keine:</p>
      <ul>
        <li>YouTube-Videos,</li>
        <li>Google Maps,</li>
        <li>Social-Media-Plugins,</li>
        <li>Newsletter-Dienste,</li>
        <li>Terminbuchungs- oder Kalender-Tools,</li>
        <li>Analyse- oder Marketingdienste,</li>
        <li>sonstigen Tracking-Technologien.</li>
      </ul>
      <p>
        Es findet daher keine weitere Datenübermittlung an Drittanbieter statt.
      </p>

      <h2>11. Kontaktformular-Dienstleister</h2>
      <p>
        Für die Übermittlung des Kontaktformulars nutzen wir den Dienst
        Web3Forms (Web3Forms, c/o Statix). Die im Formular eingegebenen Daten
        werden verschlüsselt an Web3Forms gesendet und in unserem Auftrag per
        E-Mail an uns weitergeleitet. Eine dauerhafte Speicherung der Daten
        durch Web3Forms findet nach Auskunft des Anbieters nicht statt.
        Rechtsgrundlage: Art. 6 Abs. 1 lit. b und lit. f DSGVO.
      </p>

      <h2>12. Speicherdauer</h2>
      <p>
        Wir speichern personenbezogene Daten nur so lange, wie dies für die
        jeweiligen Verarbeitungszwecke erforderlich ist oder gesetzliche
        Aufbewahrungsfristen bestehen.
      </p>
      <p>
        Nach Wegfall des jeweiligen Zwecks beziehungsweise nach Ablauf
        gesetzlicher Fristen werden die Daten gelöscht.
      </p>

      <h2>13. Ihre Rechte</h2>
      <p>Sie haben im Rahmen der gesetzlichen Vorschriften folgende Rechte:</p>
      <ul>
        <li>Recht auf Auskunft gemäß Art. 15 DSGVO,</li>
        <li>Recht auf Berichtigung gemäß Art. 16 DSGVO,</li>
        <li>Recht auf Löschung gemäß Art. 17 DSGVO,</li>
        <li>Recht auf Einschränkung der Verarbeitung gemäß Art. 18 DSGVO,</li>
        <li>Recht auf Datenübertragbarkeit gemäß Art. 20 DSGVO,</li>
        <li>Recht auf Widerspruch gegen die Verarbeitung gemäß Art. 21 DSGVO,</li>
        <li>
          Recht auf Widerruf einer erteilten Einwilligung mit Wirkung für die
          Zukunft.
        </li>
      </ul>
      <p>Zur Ausübung Ihrer Rechte können Sie sich jederzeit an uns wenden.</p>

      <h2>14. Beschwerderecht bei der Aufsichtsbehörde</h2>
      <p>
        Sie haben das Recht, sich bei einer Datenschutzaufsichtsbehörde über
        die Verarbeitung Ihrer personenbezogenen Daten zu beschweren.
      </p>
      <p>Zuständige Aufsichtsbehörde für Hessen ist:</p>
      <p>
        Der Hessische Beauftragte für Datenschutz und Informationsfreiheit
        <br />
        Postfach 3163
        <br />
        65021 Wiesbaden
        <br />
        Deutschland
      </p>

      <h2>15. Aktualität und Änderungen dieser Datenschutzerklärung</h2>
      <p>
        Wir behalten uns vor, diese Datenschutzerklärung anzupassen, sofern
        dies aufgrund geänderter gesetzlicher Anforderungen oder Änderungen
        unserer Website erforderlich wird.
      </p>
      <p>Es gilt die jeweils auf dieser Website veröffentlichte Fassung.</p>

      <p>Stand: Juni 2026</p>
    </LegalLayout>
  );
}
